import * as React from 'react';
const EightOZIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    {...props}>
    <path
      stroke="#fff"
      d="M8.48 7.5h7.79a.5.5 0 0 1 .497.441v.109l-.8 8a.5.5 0 0 1-.497.45H9.28a.5.5 0 0 1-.48-.357l-.018-.093-.8-8a.5.5 0 0 1 .39-.538L8.48 7.5Z"
    />
  </svg>
);
export default EightOZIcon;
